/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import {
  OfficeMeasurement,
  OfficeMeasurementDefault,
  PRIVILEGED_EP_SYS_VARS_ESTIMATING_MEASUREMENT,
} from '@gh/builder-shared-data';
import { DateTimeTypes, NumberTypes, whenEditMode } from '@gh/common-shared';

import { FormMode, getControlValue, setControlValue } from '@gh/core-ui';
import { SystemVarsEstimatingCommon } from '../../../resources/model/system-vars-estimating.model';

@Injectable()
export class SystemVarsEstimatingCommonSubTabFormState extends FormState<SystemVarsEstimatingCommon> {
  constructor(schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  build(common: SystemVarsEstimatingCommon, mode: FormMode): void {
    this.setMode(mode);
    this.initSchema(common);
  }

  resetMeasurementDefault(): void {
    setControlValue(this.group, 'measurementDefault', {
      [OfficeMeasurement.Imperial]: OfficeMeasurementDefault.Foot,
      [OfficeMeasurement.Metric]: void 0,
    }[getControlValue(this.group, 'measurementScale')]);
  }

  protected buildSchema(common: SystemVarsEstimatingCommon, { root }: FormStateSchema): FormRootSchema {
    return root({
      enabled: whenEditMode(),
      mode: this.mode,
      privilegedEntryPoints: [PRIVILEGED_EP_SYS_VARS_ESTIMATING_MEASUREMENT],
      children: {
        id: void 0,
        measurementScale: { privileged: PRIVILEGED_EP_SYS_VARS_ESTIMATING_MEASUREMENT, required: true },
        measurementDefault: { privileged: PRIVILEGED_EP_SYS_VARS_ESTIMATING_MEASUREMENT, required: true },
        originalItemsLocked: { privileged: PRIVILEGED_EP_SYS_VARS_ESTIMATING_MEASUREMENT },
        itemsLoaded: { enabled: false, type: DateTimeTypes.ShortDate },
        allowBulkUpdateDifferentUom: void 0,
        cloneHousePlanFromJob: void 0,
        deleteHousePlanAfterDays: { type: NumberTypes.Days },
        housePlan: { required: true },
        priceBook: void 0,
        officeId: void 0,
      },
    });
  }
}
